import { BACKEND_API_BASE_URL } from "../config";

class SubjectsAPI {
  async getAllSubjects(authToken = null, categoryId = null, schoolId = null, adminView = false) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    let url = `${BACKEND_API_BASE_URL}/api/subjects`;
    const params = [];
    if (categoryId) {
      params.push(`category_id=${categoryId}`);
    }
    if (schoolId) {
      params.push(`school_id=${schoolId}`);
    }
    if (adminView) {
      params.push(`admin_view=true`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    console.log('🔍 SubjectsAPI: Requesting URL:', url);
    console.log('🔍 SubjectsAPI: Parameters:', { categoryId, schoolId, adminView });

    const response = await fetch(url, { headers });
    if (!response.ok) {
      throw new Error("Failed to fetch subjects");
    }
    const data = await response.json();
    
    console.log('🔍 SubjectsAPI: Response data:', data);
    return data;
  }

  async createSubject(subjectData, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/subjects`, {
      method: 'POST',
      headers,
      body: JSON.stringify(subjectData),
    });
    if (!response.ok) {
      throw new Error("Failed to create subject");
    }
    return response.json();
  }

  async updateSubject(id, updateData, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/subjects/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updateData),
    });
    if (!response.ok) {
      throw new Error("Failed to update subject");
    }
    return response.json();
  }

  async deleteSubject(id, authToken = null) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/subjects/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) {
      throw new Error("Failed to delete subject");
    }
    return response.json();
  }

  async getSubjectsByCategory(categoryId) {
    const response = await fetch(
      `${BACKEND_API_BASE_URL}/api/classrooms/subjects/by-category/${categoryId}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch subjects by category");
    }
    return response.json();
  }
}

const subjectsAPI = new SubjectsAPI();
export default subjectsAPI;